module.exports = __webpack_public_path__ + "img/RUN-HEELSTRIKE-A-GAUCHE.faddfe91.svg";